import { Component, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';

@Component({
  selector: 'app-snackbar',
  templateUrl: './snackbar.component.html',
  styleUrls: ['./snackbar.component.scss'],
  standalone: false
})
export class SnackbarComponent {
  jsonDataSet: any;

  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: any) {
  }

  get getSnackBarDesign() {

    switch (this.data.snackType) {
      case 'success':
        return {
          type: this.data.snackType,
          icon: 'check_circle_outline',
          iconDesign: 'icon-success',
          stripDesign: 'successStrip',
          messageAlign: 'align-success-message'
        };
      case 'error':
          return {
            type: this.data.snackType,
            icon: 'error_outline',
            iconDesign: 'icon-error',
            stripDesign: 'errorStrip',
            messageAlign: 'align-error-message'
          }
      default:
        return {
          type: this.data.snackType,
          icon: 'check',
          iconDesign: 'icon-success',
          stripDesign: 'successStrip',
          messageAlign: 'align-message'
        };
    }
  }

  closeSnackbar() {
    this.data.snackBar.dismiss();
  }

}
